var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bookPreview" },
    [
      _setup.props.dobook.wait
        ? _c(
            "div",
            { staticClass: "dobook_wait" },
            [
              _c(_setup.vClock, { staticClass: "icon" }),
              _vm._v(" "),
              _c("h2", [_vm._v("Выполняется бронирование")]),
              _vm._v(" "),
              _c("div", { staticClass: "l" }, [
                _vm._v("Бронирование может длиться несколько минут"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "l" }, [
                _vm._v(
                  "Пожалуйста не закрывайте страничку и дождитесь результатов"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "l" }, [
                _vm._v("В "),
                _c("span", { staticClass: "l__time" }, [
                  _vm._v(_vm._s(_setup.ts_plus)),
                ]),
                _vm._v(
                  " или позже проверьте появилась ли ваша заявка в личном кабинете и присвоен ли ей номер оператора"
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tm" }, [
                _vm._v(_vm._s(_setup.props.dobook.leave_min)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.dobook.wait
        ? [
            _c(_setup.TouristPreviewNew),
            _vm._v(" "),
            _setup.props.maybook.wait
              ? _c(
                  "div",
                  [_c(_setup.Loader, { staticClass: "CruisePage__min" })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_setup.props.maybook.wait && !_setup.props.maybook.may
              ? _c("div", { staticStyle: { "margin-bottom": "100px" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "error-list",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _vm._v(
                        "\n                Обнаружено следующее:\n                "
                      ),
                      _vm._l(_setup.props.maybook.errors, function ({ text }) {
                        return _c("div", { staticClass: "error-list--li" }, [
                          _vm._v(_vm._s(text)),
                        ])
                      }),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }